import { createApi } from "@reduxjs/toolkit/query/react";
import { DomainMappingDTO } from "../../../types/DomainMapping";
import { createServiceBaseQuery } from "../../../../../store/client/serviceBaseQuery";

export const domainMappingService = createApi({
  reducerPath: "domainMappingService",
  baseQuery: createServiceBaseQuery("orpheusUri"),
  tagTypes: ["DomainMappings"],
  endpoints: (builder) => ({
    getDomainMappings: builder.query<DomainMappingDTO[], void>({
      query: () => {
        return "/api/domain-mappings";
      },
      providesTags: [{ type: "DomainMappings", id: "LIST" }],
    }),
    getDomainMappingById: builder.query<DomainMappingDTO, { domainId: string }>({
      query: (arg) => {
        const { domainId } = arg;
        return `/api/domain-mappings/${domainId}`;
      },
      providesTags: [{ type: "DomainMappings", id: "DETAIL" }],
    }),
    updateDomainMapping: builder.mutation<
      DomainMappingDTO,
      { domainMapping: DomainMappingDTO }
    >({
      query: (arg) => {
        const { domainMapping } = arg;
        return {
          url: `/api/domain-mappings`,
          method: "POST",
          body: domainMapping,
        };
      },
      invalidatesTags: [{ type: "DomainMappings", id: "DETAIL" }],
    }),
  }),
});

export const {
  useGetDomainMappingsQuery,
  useGetDomainMappingByIdQuery,
  useUpdateDomainMappingMutation,
} = domainMappingService;
